/**
 * <biosphere-price> — keeps the server-rendered price in sync with the
 * variant picker. Behaviour: reference/specs/price.md.
 *
 * No money ever gets computed here: when the picker announces a re-render,
 * this element finds its own counterpart in the fetched document (same
 * price id, falling back to same product) and swaps in that content.
 */
class BiospherePrice extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    document.addEventListener(
      "biosphere:variant-picker:update",
      (event) => this.#onVariantUpdate(event),
      { signal: this.#abort.signal },
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #onVariantUpdate(event) {
    const { productId, document: fetched } = event.detail ?? {};
    if (!fetched || productId !== this.dataset.productId) return;

    const fresh =
      fetched.querySelector(
        `biosphere-price[data-price-id="${this.dataset.priceId}"]`,
      ) ??
      fetched.querySelector(
        `biosphere-price[data-product-id="${this.dataset.productId}"]`,
      );
    if (!fresh) return;

    this.replaceChildren(...fresh.childNodes);
  }
}

if (!customElements.get("biosphere-price")) {
  customElements.define("biosphere-price", BiospherePrice);
}
